module.exports = __webpack_public_path__ + "assets/5899bd951256d5c33135324da2043256.png";